import React, { useState } from 'react';
import { useLanguage } from '../../../../contexts/LanguageContext';

/**
 * Talep özetindeki "Katılımcılar" gibi uzayabilen, virgülle ayrılmış isim listelerini göstermek
 * için: `limit`'ten fazla isim varsa ilk `limit` tanesi + "Devamını göster" bağlantısı gösterilir;
 * tıklanınca tüm liste açılır ve "Daha az göster" ile eski haline geri kapatılabilir
 * (kullanıcı isteği — bkz. Pass 22 / project_lms_module.md).
 */
const ExpandableNameList = ({ names = [], limit = 20, emptyLabel = '' }) => {
    const { th } = useLanguage();
    const [expanded, setExpanded] = useState(false);

    if (!names.length) return emptyLabel;

    const hasMore = names.length > limit;
    const visibleNames = expanded || !hasMore ? names : names.slice(0, limit);

    return (
        <>
            {visibleNames.join(', ')}
            {hasMore && (
                <>
                    {expanded ? ' ' : '… '}
                    <a role="button" tabIndex={0} className="text-primary cursor-pointer underline" onClick={() => setExpanded((prev) => !prev)}>
                        {expanded ? th('trainingRequest.summary.showLess') : th('trainingRequest.summary.showMore')}
                    </a>
                </>
            )}
        </>
    );
};

export default ExpandableNameList;
